import {
  useGetAuditMutation,
  useGetModuleAuditMutation,
  useGetAuditDetailsMutation
} from "../store/services/auditQuery";

export const useAudit = () => {
  const [
    getAudit,
    {
      data: auditData,
      isLoading: auditIsLoading,
      isError: auditIsError,
      error: auditError,
      isSuccess: auditIsSuccess,
    },
  ] = useGetAuditMutation();

  const [
    getAuditDetails,
    {
      data: auditDetailsData,
      isLoading: auditDetailsIsLoading,
      isError: auditDetailsIsError,
      error: auditDetailsError,
      isSuccess: auditDetailsIsSuccess,
    },
  ] = useGetAuditDetailsMutation();
  const [
    getModuleAudit,
    {
      data: moduleAuditData,
      isLoading: moduleAuditIsLoading,
      isError: moduleAuditIsError,
      error: moduleAuditError,
      isSuccess: moduleAuditIsSuccess,
    },
  ] = useGetModuleAuditMutation();

  return {
    getAudit,
    auditData,
    auditIsLoading,
    auditIsError,
    auditError,
    auditIsSuccess,
    getAuditDetails,
    auditDetailsData,
    auditDetailsIsLoading,
    auditDetailsIsError,
    auditDetailsError,
    auditDetailsIsSuccess,
    getModuleAudit,
    moduleAuditData,
    moduleAuditIsLoading,
    moduleAuditIsError,
    moduleAuditError,
    moduleAuditIsSuccess,
  };
};
